module.exports = __webpack_public_path__ + "assets/img/drop_down  .84631162.svg";